import { QestlabListDropdown } from 'Components/List';
import ListType from 'Components/List/QestlabListDropdown/ListType';
import { WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { hasNonEmptyValue } from 'Lib/Any';
import { Guid } from 'Lib/Guid';
import { combine, pipe } from 'Lib/Hooks/Selectors';
import deepEquals from 'Lib/Object/deepEquals';
import { useSelector } from 'react-redux';
import { Field, NumericInput, RadioGroup, TextOutput } from '../../../../Core';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { FieldSet, ListFieldSection } from '../../../../Layout';
import { IWorksheetComponent } from '../../../Core/types';

let PreparationSectionBase = ({ createWorksheetSelector }: IWorksheetComponent): JSX.Element => {
  const handId = useSelector(createWorksheetSelector!('Preparation.HandShearVane.Id')) as Guid;
  const handShearVaneImportedCalibration = useSelector(
    combine(
      [
        createWorksheetSelector!('Preparation.HandShearVaneCalibrationImportMismatch'),
        createWorksheetSelector!('Preparation.MaximumReading'),
        createWorksheetSelector!('Preparation.CalibrationFactor'),
        createWorksheetSelector!('Preparation.BladeSize'),
      ],
      (importMismatch, maxReading, factor, bladeSize) => ({
        Mismatch: importMismatch,
        MaximumReading: maxReading,
        [`Calibration${bladeSize?.value}${bladeSize?.uom}`]: factor,
      })
    ),
    deepEquals
  );
  const isHandShearVaneSelected = useSelector(
    pipe(createWorksheetSelector!('Preparation.HandShearVane'), hasNonEmptyValue)
  );

  return (
    <ListFieldSection>
      <Field input={<QestlabListDropdown />} name="Preparation.Weather" listType={ListType.Weather} maxLength={50} />
      <Field input={<NumericInput />} name="Preparation.VaneDepth" />
      <FieldSet>
        <Field
          input={<WorksheetEquipmentDropdown />}
          equipmentType="hand-shear-vane"
          name="Preparation.HandShearVane"
          importedCalibration={handShearVaneImportedCalibration}
          importModel={{ Id: handId }}
        />
        <Field input={<RadioGroup />} name="Preparation.BladeSize" label="Blade Size" />
        {isHandShearVaneSelected ? (
          <>
            <Field input={<TextOutput />} name="Preparation.CalibrationFactor" label="Factor" />
            <Field input={<TextOutput />} name="Preparation.MaximumReading" label="Maximum Reading" />
          </>
        ) : (
          <>
            <Field input={<NumericInput />} name="Preparation.CalibrationFactor" label="Factor" />
            <Field input={<NumericInput />} name="Preparation.MaximumReading" label="Maximum Reading" />
          </>
        )}
      </FieldSet>
    </ListFieldSection>
  );
};

const PreparationSection = withInjectedProps(PreparationSectionBase);
export { PreparationSection };
export default PreparationSection;
